
// import Vue from 'vue';
// import 'moment/locale/zh-cn';
import Cookies from 'js-cookie';
import { APP_ID, APP_SECRET } from '@/utils/constant';
import Qs from 'qs';
import router from '@/router';
import { logOut } from '@/utils/setup/logOut';
import { getUserInfo, getBingInfo } from '@/utils/setup/userInfo';
import { getAgreement } from '@/utils/setup/agreement';
const envJudge = require('./envJudge');

const TokenKey = 'account-Token';

let domainName = '';
if (process.env.NODE_ENV === 'development') {
  domainName = location.hostname;
} else if (process.env.NODE_ENV === 'production') {
  domainName = 'ehaomiao.com';
} else {
  domainName = 'ehaomiao.net';
}
export const CookieApi = Cookies.withAttributes({ domain: domainName, expires: 30 });

const Common = {
  /** 获取微信二维码 */
  WXLogin () {
    let search = Qs.parse(location.search, { ignoreQueryPrefix: true }); // ignoreQueryPrefix 为 true 可以去掉query的"?"号
    console.log('wxLogin search: ', search);
    if (search.hasOwnProperty('code')) {
      delete search.code;
    }
    let query;
    if (Object.keys(search).length) {
      query = '?' + Qs.stringify(search);
    } else {
      query = Qs.stringify(search);
    }

    const url = location.origin + location.pathname + query;
    console.log('wxLogin redirect: ', query, url);

    new WxLogin({
      self_redirect: false,
      id: 'login_container',
      appid: 'wx9f465e3a3a5f474a', // 当前网站应用的 appId
      scope: 'snsapi_login',
      redirect_uri: encodeURI(url),
      state: `${APP_ID}-${APP_SECRET}`
    });
  },
  /** 倒计时 */
  countDown (second) {
    second.value = 60;
    let countInterval = setInterval(() => {
      if (second.value > 1) {
        second.value--;
      } else {
        clearInterval(countInterval);
        second.value = 0;
      }
    }, 1000);
  },
  /** 设置a-modal的默认样式 */
  setModalStyle (self) {
    self.$nextTick(() => {
      let modal = document.getElementsByClassName('ant-modal');
      modal && (modal[0].style.width = '480px');
    });
  },
  /**
   *  数据保存到localStorage
   * @param key
   * @param value
   */
  setLocal (key, value) {
    if (value === undefined || key === undefined) {
      return;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      localStorage[key] = value;
    } else if (typeof value === 'object' && value !== null) {
      localStorage[key] = JSON.stringify(value);
    }
  },

  /**
   * 获取localStorage数据
   * @param key
   * @returns {any}
   */
  getLocal (key) {
    if (!localStorage[key]) {
      return;
    }
    let value = localStorage[key];
    let index1 = value.indexOf('[');
    let index2 = value.indexOf('{');
    if (index1 >= 0 || index2 >= 0) {
      value = JSON.parse(localStorage[key]);
    }
    return value;
  },
  /* 获取access token */
  getToken () {
    if (getUrlParams('appType') && sessionStorage.appType != getUrlParams('appType')) {
      sessionStorage.appType = getUrlParams('appType');
    }
    if (Common.isPc()) {
      window.document.title = '浩邈账号中心';
    } else if (getUrlParams('appType') != 1) {
      setTimeout(() => {
        let routername = router.currentRoute.value.name;
        if (routername != 'appLogin') {
          window.document.title = '账号与安全';
        }
      }, 500);
    }
    if (getUrlParams('token') && getUrlParams('PlatFormType') == 1 && getUrlParams('appType') == 1) {
      let token = getUrlParams('token');
      token && CookieApi.set(TokenKey, token);
      sessionStorage.PlatFormType = 1;
      sessionStorage.appType = 1;

      return getUrlParams('token');
    } else if (getUrlParams('token') && getUrlParams('PlatFormType') == 2) {
      let token = getUrlParams('token');
      token && CookieApi.set(TokenKey, token);
      sessionStorage.PlatFormType = 2;

      let applyType = getUrlParams('applyType');
      if (applyType) {
        sessionStorage.applyType = applyType;
      }

      return getUrlParams('token');
    } else {
      return CookieApi.get(TokenKey);
    }
  },
  isPc () {
    const userAgent = navigator.userAgent;
    const touchSupported = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

    const isPc = !/Mobile/.test(userAgent) &&
                !touchSupported &&
                !isMobilePlatform() &&
                !isAppPlatform();

    return isPc;
  },

  /** 存储 token */
  setToken (token) {
    return CookieApi.set(TokenKey, token);
  },
  /** 清除 token */
  removeToken () {
    return CookieApi.remove(TokenKey);
  }
};
function getUrlParams (key) {
  var url = window.location.search.substr(1);
  if (url == '') {
    return false;
  }
  var paramsArr = url.split('&');
  for (var i = 0; i < paramsArr.length; i++) {
    var combina = paramsArr[i].split('=');
    if (combina[0] == key) {
      return combina[1];
    }
  }
  return false;
}

export function checkBrowser () {
  let sBrowser;
  const sUsrAg = navigator.userAgent;
  if (sUsrAg.indexOf('Firefox') > -1) {
    sBrowser = 'Mozilla Firefox';
    // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
  } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
    sBrowser = 'Opera';
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
  } else if (sUsrAg.indexOf('Trident') > -1) {
    sBrowser = 'Microsoft Internet Explorer';
    // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
  } else if (sUsrAg.indexOf('Edge') > -1) {
    sBrowser = 'Microsoft Edge';
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
  } else if (sUsrAg.indexOf('Chrome') > -1) {
    // sBrowser = 'Google Chrome or Chromium';
    sBrowser = 'Google Chrome';
    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
  } else if (sUsrAg.indexOf('Safari') > -1) {
    sBrowser = 'Apple Safari';
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
  } else {
    sBrowser = '未知';
  }

  return sBrowser;
}

export function isMobilePlatform () {
  const mobile = !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.toLowerCase().match(/MicroMessenger/i) || !!navigator.userAgent.toLowerCase().match(/hmOs/i); ;
  return mobile;
}
export function isAppPlatform () {
  let agent = navigator.userAgent.toLowerCase();
  let isApp = false;
  if (agent.indexOf('android') >= 0 || agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0 || agent.indexOf('hmOs') >= 0) {
    isApp = true;
  }
  return isApp;
}

export function handleLoginState () {
  if (isMobilePlatform()) { return; }
  const token = localStorage.getItem('ACCESS_TOKEN');
  const currentToken = Common.getToken();
  console.log('tab token, currentToken: ', token, currentToken);
  const pathname = location.pathname;
  const searchObj = Qs.parse(location.search, { ignoreQueryPrefix: true });
  if (!token && !currentToken) { // 都没赋值时
    if (pathname.length > 1 && !pathname.includes('login')) { // 当前不为登录页
      logOut();
    }
    return; // 不往下执行
  }
  if (token == 'undefined' && !currentToken) {
    return;
  }
  if (token !== currentToken) {
    localStorage.setItem('ACCESS_TOKEN', currentToken);
    if (searchObj.redirect) {
      location.href = searchObj.redirect;
    } else {
      location.href = location.origin + envJudge();
    }
  }

  if (token && currentToken && token === currentToken) {
    if (pathname.length > 1 && pathname.includes('login')) { // 当前为登录页
      if (searchObj.redirect) {
        location.href = searchObj.redirect;
      } else {
        if (router.currentRoute.value.name == 'loginDevice') {
          return;
        }
        router.push('/');
      }
    }
  }
}

let platFormType;
export function getPlatFormType () {
  let agent = navigator.userAgent.toLowerCase();
  // 检查是否为鸿蒙系统
  if (agent.indexOf('hmos') >= 0) {
    platFormType = 'hmos';
    return 'hmos';
  } else if (agent.indexOf('android') >= 0) {
    platFormType = 'android';
    return 'android';
  } else if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    platFormType = 'ios';
    return 'ios';
  }
  return 'Other';
}
export function getAppToken () {
  if (!platFormType) {
    getPlatFormType();
  }
  return new Promise((resolve, reject) => {
    let token = Common.getToken();
    let count = 0;
    if (token) {
      resolve(token);
      try {
        clearInterval(countInterval);
      } catch (error) {};
      return;
    }

    let countInterval = setInterval(() => {
      if (platFormType == 'hmos') {
        try {
          token = window.HarmonyBridge.getToken();
        } catch (err) {}
      } else if (platFormType == 'android') {
        try {
          token = window.android.getToken();
        } catch (err) {}
      } else if (platFormType == 'ios') {
        try {
          token = window.webkit.messageHandlers.getToken.postMessage(null);
        } catch (err) {}
      }

      if (token) {
        Common.setToken(token);
        sessionStorage.PlatFormType = 1;
        clearInterval(countInterval);
        resolve(token);
      } else {
        count++;
        if (count > 1500) { // 5分钟未取得将不再主动获取
          clearInterval(countInterval);
          count = 0;
          reject('获取token超时');
        }
      }
    }, 200);
  });
}

export function receiveToken (token) {
  return new Promise((resolve, reject) => {
    // const PlatForm = sessionStorage.getItem('PlatFormType');
    // if (PlatForm) {
    //   return false;
    // }
    if (token) {
      Common.setToken(token);
      sessionStorage.PlatFormType = 1;

      setTimeout(() => {
        getUserInfo();
        getBingInfo();
        getAgreement();
      }, 0);
      resolve(token);
    } else {
      resolve(false);
    }
  });
}

export function appGoback () {
  if (!platFormType) {
    getPlatFormType();
  }
  let routername = router.currentRoute.value.name;
  const PlatForm = sessionStorage.getItem('PlatFormType');
  if (routername == 'accountSet') {
    if (platFormType == 'hmos') {
      window.HarmonyBridge.onNavToApp();
    } else if (platFormType == 'android') {
      window.android.onNavToApp();
    } else if (platFormType == 'ios') {
      window.webkit.messageHandlers.onNavToApp.postMessage(null);
    }
  } else if (routername == 'rebindPhone' || routername == 'modifyPwd') {
    router.replace({
      name: 'accountSet',
      query: {PlatFormType: PlatForm || '1'}
    });
  } else {
    router.go(-1);
  }
}

export default Common;
